import { useEffect } from 'react';

export const useWorkflowPreTaskLifecycle = ({ onWorkflowFetch }) => {
  useEffect(() => {
    onWorkflowFetch();
  }, [onWorkflowFetch]);
};
